import { Component } from "react";
import { PAGE_ELEMENT, PAGE_SIZE, PAGE_TYPE } from "./ComponentList";
import {
  DKButton,
  DKIcons,
  DKInputForm,
  INPUT_TYPE,
  DKLabel,
  showAlert,
} from "deskera-ui-library";

import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";

import ApiManager from "../../managers/ApiManager";

import Text from "./canvas_components/Text";
import ComponentManager from "./ComponentManager";
import Button from "./canvas_components/Button";
import Image from "./canvas_components/Image";
import Social from "./canvas_components/Social";
import Collection from "./canvas_components/Collection";
import ImageText from "./canvas_components/ImageText";
import Form from "./canvas_components/Form";
import VideoSection from "./canvas_components/VideoSection";
import Utility, { shiftArrayElement } from "../../utility/Utility";
import HTMLGenerator from "./HtmlGenerator";
import ElementList from "./ElementList";
import CustomHtml from "./canvas_components/CustomHtml";
import { getViewportSize, isViewportLarge } from "../../utility/ViewportSizeUtils";
import { VIEWPORT_SIZES } from "../../constants/Constant";
import PlaceholderButton from "./canvas_components/PlaceholderButton";
import { stringSanitizer } from "../../managers/common/CommonUtil";

/*
PROPS
- previewMode
- readOnly
- components
- onComponentSelect(index)
- currentComponentIndex
- onTapOutside
- onSave
- viewType (PAGE_SIZE)
- pageType (PAGE_TYPE)
- hash
*/

class Canvas extends Component {
  constructor(props) {
    super(props);
    this.state = {
      viewType: this.props.viewType,
      components: this.props.components,
      scripts: this.props.scripts,
      metaData: this.props.metaData,
      currentComponentIndex: this.props.currentComponentIndex,
      previewMode: this.props.previewMode,
      readOnly: this.props.readOnly,
      needToShowImagePopup: false,
      isInlineTextEdit: false,
      showElement: false,
    };
    this.isEditing =
      this.props.previewMode === true || this.props.readOnly === true
        ? false
        : true;
  }
  componentWillReceiveProps(nextProps) {
    this.setState({
      viewType: nextProps.viewType,
      components: nextProps.components,
      scripts: nextProps.scripts,
      metaData: nextProps.metaData,
      currentComponentIndex: nextProps.currentComponentIndex,
    });
  }

  //////////////////////////////////////////////////////////////////////////////////////////
  //////////////////////////////////////////////////////////////////////////////////////////
  //////////////////////////////////////////////////////////////////////////////////////////

  render() {
    return (
      <div
        id="canvas"
        className=" border-box position-relative position-absolute "
        style={{ width: this.props.width || this.getWidth(), maxWidth: 1200, outline: "none" }}
        onMouseLeave={this.onCanvasLeave}
      >
        <DragDropContext
          onDragStart={this.handleDragStart}
          onDragEnd={this.handleDragEnd}
        >
          <Droppable
            droppableId="pageDesignerCanvas"
            isDropDisabled={!this.isEditing}
          >
            {(provided, snapshot) => (
              <div
                ref={provided.innerRef}
                id={"dk-page-canvas-component"}
                className={
                  "column z-index-1 align-items-center bg-white border-box mb-r border-radius-s parent-width " +
                  (this.state.previewMode ? "" : "shadow-s p-r")
                }
                {...provided.droppableProps}
              >
                {this.renderAllComponents()}
                {provided.placeholder}
              </div>
            )}
          </Droppable>
        </DragDropContext>
        {!this.state.previewMode &&
          this.state.components.length > 0 &&
          this.getFooterButtons()}
        <div />
        {!this.state.previewMode &&
          this.state.needEmailForm &&
          this.getEmailForm()}
      </div>
    );
  }

  generateHTML = () => {
    const generator = new HTMLGenerator();

    return generator.getHTML(
      this.state.components,
      this.state.scripts,
      this.state.metaData,
      this.props.hash,
      this.props.pageType
    );
  };

  //////////////////////////////////////////////////////////////////////////////////////////
  //////////////////////////////////////////////////////////////////////////////////////////
  //////////////////////////////////////////////////////////////////////////////////////////

  getWidth() {
    if (this.state.previewMode) {
      return "100%";
    }
    if (this.state.viewType === PAGE_SIZE.WEB) {
      return 940;
    }
    if (this.state.viewType === PAGE_SIZE.PHONE) {
      if(isViewportLarge()) {
        return 370;
      } else {
        return "100%"
      }
    }
    if (this.state.viewType === PAGE_SIZE.TABLET) {
      return 700;
    }

    return 600;
  }

  //////////////////////////////////////////////////////////////////////////////////////////
  //////////////////////////////////////////////////////////////////////////////////////////
  //////////////////////////////////////////////////////////////////////////////////////////

  renderAllComponents() {
    let arr = [];
    this.state.components.forEach((data, index) => {
      arr.push(this.getComponent(data, index));
    });
    if (arr.length === 0) {
      arr.push(this.getBlankCanvas());
    }
    return arr;
  }

  //////////////////////////////////////////////////////////////////////////////////////////
  //////////////////////////////////////////////////////////////////////////////////////////
  //////////////////////////////////////////////////////////////////////////////////////////

  getComponent(data, index) {
    return (
      <Draggable
        index={index}
        key={`component-${index}`}
        draggableId={`component-${index}`}
        isDragDisabled={!this.isEditing}
      >
        {(provided, snapshot) => (
          <>
            {this.isEditing && this.getCanvasTootip(index, data.type)}
            <div
              ref={provided.innerRef}
              {...provided.draggableProps}
              {...provided.dragHandleProps}
              id={`canvas-${index}-component`}
              className={
                this.isEditing
                  ? "cursor-hand canvas-section position-relative"
                  : ""
              }
              style={{
                width: "100%",
                display: "flex",
                flexDirection: "column",
                alignItems: data.style ? data.style.alignSelf : null,
                ...provided.draggableProps.style,
                outline: "none",
              }}
              onClick={() => {
                if (
                  this.isEditing === true &&
                  this.state.currentComponentIndex !== index
                ) {
                  let screenSize = getViewportSize()
                  if (screenSize === VIEWPORT_SIZES.EXTRA_SMALL || screenSize === VIEWPORT_SIZES.SMALL) {
                    this.onMobileToolTip(index)
                  } else {
                    this.props.onComponentSelect(index);
                  }
                }
              }}
              onMouseOver={(e) => {
                if (
                  this.state.currentComponentIndex !== null &&
                  this.state.currentComponentIndex !== undefined
                ) {
                  const div = document.getElementById(`dummy-focus-div`);
                  div.focus();
                }
                this.onMouseParentSection(`canvas-${index}-component`);
              }}
            >
              {data.type === PAGE_ELEMENT.TEXT && this.getText(data, index)}
              {data.type === PAGE_ELEMENT.BUTTON && this.getButton(data, index)}

              {data.type === PAGE_ELEMENT.IMAGE && this.getImage(data, index)}

              {data.type === PAGE_ELEMENT.VIDEO &&
                this.getVideoSection(data, index)}

              {data.type === PAGE_ELEMENT.SOCIAL_BUTTONS &&
                this.getSocialSection(data, index)}

              {(data.type === PAGE_ELEMENT.COLLECTION ||
                data.type === PAGE_ELEMENT.ICON) &&
                this.getCollectionSelection(data, index)}

              {data.type === PAGE_ELEMENT.IMAGE_TEXT &&
                this.getImageTextDefaultData(data, index)}

              {data.type === PAGE_ELEMENT.FORM &&
                this.getFormsDefaultData(data, index)}

              {data.type === PAGE_ELEMENT.CUSTOM_HTML &&
                this.getCustomHtmlDefaultData(data, index)}
            </div>
          </>
        )}
      </Draggable>
    );
  }

  getImage(data, index) {
    return (
      <Image
        data={data}
        borderStyle={ComponentManager.getCurrentComponentBorder(
          this.state.currentComponentIndex,
          index,
          this.isEditing
        )}
        isEditing={this.isEditing}
        showImagePopup={
          this.isEditing &&
          index === this.state.currentComponentIndex &&
          this.state.needToShowImagePopup
        }
        onClosePopUp={this.closeImagePopup}
        onValueChange={(value) => {
          this.onValueChange(value, this.state.currentComponentIndex);
        }}
      />
    );
  }

  getVideoSection(data, index) {
    return (
      <VideoSection
        data={data}
        borderStyle={ComponentManager.getCurrentComponentBorder(
          this.state.currentComponentIndex,
          index,
          this.isEditing
        )}
        isEditing={this.isEditing}
      />
    );
  }

  getText(data, index) {
    return (
      <Text
        data={data}
        index={index}
        isEditing={this.isEditing}
        borderStyle={ComponentManager.getCurrentComponentBorder(
          this.state.currentComponentIndex,
          index,
          this.isEditing
        )}
        inlineEditing={
          this.isEditing &&
          index === this.state.currentComponentIndex &&
          this.state.isInlineTextEdit
        }
        onCloseInlineEdit={this.closeInlineEdit}
        onShowInlineEdit={this.showInlineEdit}
        enableInlineTextEdit={this.showInlineEdit}
        onTextChange={(value, index, colIndex, colComponetIndex) =>
          this.onCollectionValueChange(value, index, colIndex, colComponetIndex)
        }
      />
    );
  }
  onCollectionValueChange = (value, index, columnIndex, colComponetIndex) => {
    let components = [...this.state.components];
    if (!Utility.isEmpty(index) && components[index]) {
      if (!Utility.isEmpty(columnIndex)) {
        if (!Utility.isEmpty(colComponetIndex)) {
          components[index].value[columnIndex].value[colComponetIndex].value = value;
        } else {
          components[index].value[columnIndex].value = value;
        }
        this.props.onDataChange(components[index]);
      } else {
        components[index].value = value;
        this.props.onDataChange(components[index], index, columnIndex);
      }
    }
  };
  showInlineEdit = () => {
    this.setState({ isInlineTextEdit: true });
  };
  getButton(data, index) {
    return (
      <Button
        data={data}
        index={index}
        isEditing={this.isEditing}
        borderStyle={ComponentManager.getCurrentComponentBorder(
          this.state.currentComponentIndex,
          index,
          this.isEditing
        )}
      />
    );
  }

  getCollectionSelection(data, index) {
    return (
      <Collection
        data={data}
        borderStyle={ComponentManager.getCurrentComponentBorder(
          this.state.currentComponentIndex,
          index,
          this.isEditing
        )}
        onMouseOverInner={this.onMouseInnerSection}
        onTextChange={(value, index, type) =>
          this.onChangeCollectionValue(
            value,
            this.state.currentComponentIndex,
            index,
            type
          )
        }
        onValueChange={(value, index) => {
          this.onChangeCollectionValue(
            value,
            this.state.currentComponentIndex,
            index,
            "icon"
          );
        }}
      />
    );
  }

  getImageTextDefaultData(data, index) {
    return (
      <ImageText
        viewType={this.state.viewType}
        data={data}
        borderStyle={ComponentManager.getCurrentComponentBorder(
          this.state.currentComponentIndex,
          index,
          this.isEditing
        )}
        onTextChange={(value, index, type) =>
          this.onChangeCollectionValue(
            value,
            this.state.currentComponentIndex,
            index,
            type
          )
        }
        onValueChange={(value, index) => {
          this.onChangeCollectionValue(
            value,
            this.state.currentComponentIndex,
            index,
            "image"
          );
        }}
      />
    );
  }

  getSocialSection(data, index) {
    return (
      <Social
        data={data}
        isEditing={this.isEditing}
        borderStyle={ComponentManager.getCurrentComponentBorder(
          this.state.currentComponentIndex,
          index,
          this.isEditing
        )}
      />
    );
  }

  getFormsDefaultData(data, index) {
    return (
      <Form
        viewType={this.state.viewType}
        data={data}
        hash={this.props.hash}
        isEditing={this.isEditing}
        borderStyle={ComponentManager.getCurrentComponentBorder(
          this.state.currentComponentIndex,
          index,
          this.isEditing
        )}
        onMouseOverInner={this.onMouseFormSection}
      />
    );
  }

  getCustomHtmlDefaultData(data, index) {
    return (
      <CustomHtml
        data={data}
        index={index}
        isEditing={this.isEditing}
        borderStyle={ComponentManager.getCurrentComponentBorder(
          this.state.currentComponentIndex,
          index,
          this.isEditing
        )}
      />
    );
  }

  //////////////////////////////////////////////////////////////////////////////////////////
  //////////////////////////////////////////////////////////////////////////////////////////
  //////////////////////////////////////////////////////////////////////////////////////////

  showEmailForm = () => {
    this.setState({
      needEmailForm: true,
    });
    this.props.onTapOutside();
  };
  hideEmailForm = () => {
    this.setState({
      needEmailForm: false,
    });
  };

  getEmailForm() {
    let formData = [
      {
        key: "email",
        icon: DKIcons.ic_email,
        title: "To",
        type: INPUT_TYPE.EMAIL,
        value: "",
      },
      {
        key: "subject",
        icon: DKIcons.ic_text,
        title: "Subject",
        type: INPUT_TYPE.TEXT,
        value: "",
      },
    ];
    return (
      <div className="transparent-background">
        <div className="popup-window" style={{ maxWidth: 450 }}>
        <DKInputForm
          title="Send test email"
          className=""
          fields={formData}
          onSubmit={(data) => {
            ApiManager.sendEmail(
              data[1].value,
              data[0].value,
              this.generateHTML(),
              () => {
                this.hideEmailForm();
              }
            );
          }}
          onCancel={this.hideEmailForm}
        />
        </div>
      </div>
    );
  }

  //////////////////////////////////////////////////////////////////////////////////////////
  //////////////////////////////////////////////////////////////////////////////////////////
  //////////////////////////////////////////////////////////////////////////////////////////

  getFooterButtons() {
    return (
      <div
        className="row justify-content-center mt-l flex-wrap "
      >
        {this.props.pageType === PAGE_TYPE.CAMPAIGN && (
          <DKButton
            className="z-index-2 bg-gray1 border-m mb-m"
            title="Send test email"
            icon={DKIcons.ic_email}
            onClick={this.showEmailForm}
          />
        )}
        {this.props.pageType !== PAGE_TYPE.FUNNEL && !this.state.readOnly && (
          <DKButton
            className="z-index-2 bg-app ml-m text-white mb-m"
            title="Save & Proceed"
            onClick={() => {
              this.props.onSave();
            }}
          />
        )}
      </div>
    );
  }

  /////////////////////////////

  getBlankCanvas = () => {
    return (
      <div
        className="column m-v-xl parent-width justify-content-center align-items-center ss-m"
        style={{ minHeight: 230, border: "1px dashed #80808094" }}
      >
        <DKLabel text="No elements found" className="fw-m" />
        <DKLabel
          text="Please add elements from right panel to design"
          className="text-gray mt-s"
        />
      </div>
    );
  };

  /////////////////////////////////////////////////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////////////////////////

  changeTootipEvent = (index, action, type) => {
    switch (action) {
      case "edit":
        this.props.onComponentSelect(index, (type === PAGE_ELEMENT.FORM));
        if (type === PAGE_ELEMENT.IMAGE) {
          this.setState({ needToShowImagePopup: true });
        }
        if (type === PAGE_ELEMENT.TEXT) {
          this.setState({ isInlineTextEdit: true });
        }
        break;
      case "delete":
        this.onDeleteComponent(index);
        break;
      case "up":
        let newComponents = shiftArrayElement(
          this.state.components,
          index,
          index - 1
        );
        this.saveComponent(newComponents);
        break;
      case "down":
        let newComponent = shiftArrayElement(
          this.state.components,
          index,
          index + 1
        );
        this.saveComponent(newComponent);
        break;
      case "copy":
        this.onCopyComponent(index);
        break;
      case "add":
        this.showElement();
        break;
      default:
        break;
    }
  };

  setTooltip = (id) => {
    if (this.props.readOnly) {
      return;
    }
    let index = id.replace("canvas-", "").replace("-component", "");
    let canvas = document.getElementById(id);
    let tooltip = document.getElementById(`tooltip-${index}-component`);
    if (tooltip) {
      tooltip.style.display = "flex";
      tooltip.style.top = canvas.offsetTop - 30 + "px";
      canvas.className = canvas.className + " canvas-active";
    }
  };

  onMouseFormSection = (e) => {
    e.preventDefault();
    this.onCanvasLeave();
    if (e.target.parentNode.parentNode.id) {
      this.setTooltip(e.target.parentNode.parentNode.id);
    }
  };

  onMouseInnerSection = (e) => {
    e.preventDefault();

    if (this.isDragOngoing) return;

    this.onCanvasLeave();
    if (e.target.parentNode.parentNode.parentNode.id) {
      this.setTooltip(e.target.parentNode.parentNode.parentNode.id);
    } else if (e.target.parentNode.parentNode.parentNode.parentNode.id) {
      this.setTooltip(e.target.parentNode.parentNode.parentNode.parentNode.id);
    }
  };

  onMouseParentSection = (id) => {
    this.onCanvasLeave();
    this.setTooltip(id);
  };

  onCanvasLeave = () => {
    const allTooltip = document.getElementsByClassName("dk-tootip");
    for (let i = 0; i < allTooltip.length; i++) {
      allTooltip[i].style.display = "none";
      this.hideElement();
    }
    const elements = document.getElementsByClassName(
      "canvas-section canvas-active"
    );
    if (elements.length > 0) {
      elements[0].classList.remove("canvas-active");
    }
  };

  saveComponent = (newComponents) => {
    this.setState({ components: newComponents });
  };

  onDeleteComponent = (index) => {
    const buttons = [
      {
        title: "Cancel",
        className: "bg-gray1 border-m",
      },
      {
        title: "Delete",
        className: "bg-red text-white ml-r",
        onClick: () => {
          this.props.onDeleteCanvasComponent(index);
        },
      },
    ];
    showAlert(
      "Delete element?",
      "Deleting this element will delete it permanently.",
      buttons
    );
  };

  showElement = () => {
    this.setState({ showElement: true });
  };

  hideElement = () => {
    this.setState({ showElement: false });
  };

  getCanvasTootip = (index, type) => {
    return (
      <div
        className="column position-absolute dk-tootip"
        id={`tooltip-${index}-component`}
        style={{ right: 13, display: "none", width: "auto" }}
      >
        <div className="row ">
          {index !== this.state.components.length - 1 && (
            <DKButton
              icon={DKIcons.ic_arrow_down2}
              className="bg-gray1 border-m border-radius-none"
              onClick={() => {
                this.changeTootipEvent(index, "down", type);
              }}
            />
          )}
          {index !== 0 && (
            <DKButton
              icon={DKIcons.ic_arrow_up2}
              className="bg-gray1 border-m border-radius-none"
              onClick={() => {
                this.changeTootipEvent(index, "up", type);
              }}
            />
          )}
          <DKButton
            icon={DKIcons.ic_copy}
            className="bg-gray1 border-m border-radius-none"
            onClick={() => {
              this.changeTootipEvent(index, "copy", type);
            }}
          />
          <DKButton
            icon={DKIcons.ic_add}
            className="bg-gray1 border-m border-radius-none"
            onClick={() => {
              this.changeTootipEvent(index, "add", type);
            }}
          />
          <PlaceholderButton
            pageType={this.props.pageType}
            componentData={{
              elementType: type,
              index,
            }}
            onToolInitialized={() => {
              this.changeTootipEvent(index, "edit", type);
              this.hideElement();
            }}
            onPlaceholderSelected={() => {
              this.changeTootipEvent(index, "edit", type);
            }}
          />
          <DKButton
            icon={DKIcons.ic_edit}
            className="bg-gray1 border-m border-radius-none"
            onClick={() => {
              this.changeTootipEvent(index, "edit", type);
            }}
          />
          <DKButton
            icon={DKIcons.ic_delete}
            className="bg-gray1 border-m border-radius-none"
            onClick={() => {
              this.changeTootipEvent(index, "delete", type);
            }}
          />
        </div>
        <div className="z-index-1">
          {this.state.showElement && (
            <ElementList
              pageType={this.props.pageType}
              className="p-r shadow-l"
              onAdd={(type) => this.onAddComponent(index, type)}
            />
          )}
        </div>
      </div>
    );
  };

  closeImagePopup = () => {
    this.setState({ needToShowImagePopup: false });
  };

  closeInlineEdit = () => {
    this.setState({ isInlineTextEdit: false });
  };

  onCopyComponent = (index) => {
    let components = [...this.state.components];
    let tempMyObj = { ...components[index] };
    components.splice(index + 1, 0, JSON.parse(JSON.stringify(tempMyObj)));
    this.saveComponent(components);
    this.props.onCopyComponent(components);
    this.elementToScroll(index);
  };

  onAddComponent = (index, type) => {
    this.hideElement();
    let components = [...this.state.components];
    components.splice(
      index + 1,
      0,
      ComponentManager.getComponentDefaultData(type)
    );
    this.saveComponent(components);
    this.props.onCopyComponent(components);
    this.elementToScroll(index);
  };

  elementToScroll = (index) => {
    var elmnt = document.getElementById(`canvas-${index + 1}-component`);
    if (elmnt) {
      elmnt.scrollIntoView({
        behavior: "smooth",
        block: "center",
        inline: "start",
      });
    }
  };

  /////////////////////////////////////////////////////////////////////////////////////////////
  onValueChange = (value, index) => {
    const sanitizedText = stringSanitizer(value);
    let components = [...this.state.components];
    if (index !== null && index !== undefined && components[index]) {
      components[index].value = sanitizedText;
      this.props.onDataChange(components[index]);
    }
  };

  onChangeCollectionValue = (value, index, arrIndex, type) => {
    let components = [...this.state.components];
    if (index !== null && index !== undefined && components[index]) {
      components[index].value[arrIndex][type] = value;
      this.props.onDataChange(components[index]);
    }
  };
  /////////////////////////////////////////////////////////////////////////////////////////////

  //////////////////////////////////////////////////////////////////////////////////////////
  ////////////////////////   DRAG DROP ANIMATIONS  - NOT IN USE   //////////////////////////
  //////////////////////////////////////////////////////////////////////////////////////////

  handleDragEnd = (result) => {
    this.isDragOngoing = false;
    const { source, destination } = result;

    /* Dropped out of Canvas or dropped on it's original place */
    if (!destination || source.index === destination.index) {
      return;
    }

    const newComponentsArr = shiftArrayElement(
      this.state.components,
      source.index,
      destination.index
    );

    this.setState({
      components: newComponentsArr,
    });
  };

  handleDragStart = (event) => {
    this.onCanvasLeave();
    this.props.onTapOutside();
    this.isDragOngoing = true;
  };

  onMobileToolTip = (index) => {
    this.onMouseParentSection(`canvas-${index}-component`)
  }
  //////////////////////////////////////////////////////////////////////////////////////////
  ///////////////////////////////  END DRAG DROP ANIMATIONS    /////////////////////////////
  //////////////////////////////////////////////////////////////////////////////////////////
}

export default Canvas;
